// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"5b623cd8","115":"b171988c","234":"fa8ab649","290":"72b57969","377":"395a4d46","613":"c055395c","667":"b6dd3c96"}[chunkId] + ".chunk.js";
};